import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import DonateForm from "./donate_form";
import PaypalImg from "../../assets/img/paypal.png";

const PayPalButton = ({
  setActivePaymentMethod,
  activePaymentMethod,
  selectedPlan,
}) => {
  const handlePayPal = () => {
    setActivePaymentMethod("paypal");
  };

  return (
    <>
      <div className="payment-option" onClick={handlePayPal}>
        <span>
          <input
            type="radio"
            name="paymentMethod"
            value="paypal"
            checked={activePaymentMethod === "paypal"}
            onChange={handlePayPal}
          />
          <img src={PaypalImg} height={50} width={50} alt="PaypalImg" />
          Paypal
        </span>
        {activePaymentMethod === "paypal" && (
          <PayPalScriptProvider
            options={{
              "client-id": process.env.REACT_APP_PAYPAL_CLIENT_ID,
              components: "buttons",
              currency: "USD",
            }}
          >
            <DonateForm
              setActivePaymentMethod={setActivePaymentMethod}
              selectedPlan={selectedPlan}
            />
          </PayPalScriptProvider>
        )}
      </div>
    </>
  );
};

export default PayPalButton;
